import s from './style.module.css';
import Button from "@UI/Button";
import Textarea from "@UI/Textarea";
import {useAddAlert} from "@/hooks/useAddAlert";
import { useEffect, useState } from 'react';
import { directionOrdersApi } from '@api';
const TableRow = ({data, ind, setModal, isUniversalBalance, Paid, setState}) => {
  
    const [comment, setComment] = useState(data.comment? data.comment: '');
    const [savedComment, setSavedComment] = useState(data.comment? data.comment: '');
    const addAlert = useAddAlert();
    const commentData = data.comment;
    useEffect(() => {
        setComment(commentData);
        setSavedComment(commentData);
    }, [commentData]);
    const saveComment = () => {
        if (comment !== savedComment){
            const formData = new FormData();
            const newComment = comment;
            formData.append('comment', newComment);
            formData.append('id', data.id);
            directionOrdersApi.addComment(formData).then(res => {
                if (res?.data?.status !== 'success')
                addAlert({
                    title: `УПС! Возникла ошибка... Комментарий не сохранен...`,
                    text: '',//res?.message,
                    type: 'error'
                });
                else {
                    setSavedComment(newComment);
                    setState((state) => {
                        return state.map((el) => el.id === data.id? { ...data, comment: newComment }: el)
                    });
                }
            })
        }
    }
    useEffect(() => {
        const id = setInterval(saveComment, 2000);
        return () => clearInterval(id);
    }, [comment, savedComment])
    return (
        <tr className={s.row}>
            <td className={s.td}>{ind + 1}</td>
            <td className={s.td}>{ data?.class_id !== null ? data?.class?.title : data.direction?.name }</td>
            <td className={s.td}>{data.children?.name}</td>
            <td className={s.td}>{data.class ? data.class?.classUser?.find((el) => (el?.user_id == data?.children.id && el?.user_id))?.amount ?? 0 : (data?.tariff?.first_price || data?.tariff?.first_price === 0) ? data?.tariff?.first_price :  ''}</td>
            <td className={s.td}>{Number(data.children?.balance).toFixed(0)}</td>
            <td className={s.td}>{Number(data.children?.balance_euro).toFixed(2)}</td>
            <td className={s.td}>{Number(data.children?.balance_dollar).toFixed(2)}</td>
            <td className={s.td}>
                {data?.tariff?.type === 'hour' || data?.tariff?.type === 'minute'
                    ? Number(data?.private_balance ?? 0).toFixed(2)
                    : data.buy_hours ? data.buy_hours : '-'}
            </td>
            <td className={s.td}><Paid order={data} /></td>
            <td className={s.td}>-</td>
            <td className={s.td}>
                {!isUniversalBalance && (Number(data?.class?.classUser?.filter(classUser => classUser.user_id === data?.children_id && classUser.deleted_at === null)[0]?.amount) > 0 || (data?.tariff?.id !== undefined && data?.tariff?.type !== 'free') && data.status_payment > 0) && (
                // {data?.tariff?.id !== undefined && data?.tariff?.type !== 'free' && data.status_payment > 0 && (
                    <Button
                        className={s.button}
                        styles={'accent'}
                        action={() => setModal({active: true, type: 'extend', data: data})}
                    >Продлить обучение</Button>
                )}
            </td>
            <td className={s.td}>
                <Textarea
                    className={s.orderComment}
                    placeholder='Введите комментарий'
                    value={comment}
                    onChange={(e)=>setComment(e.target.value)}
                    style={{width: '200px'}}
                />
            </td>
        </tr>
    )
}
export default TableRow;
